import ResetPasswordFormContainer from './ResetPasswordFormContainer';

export default ResetPasswordFormContainer;
